import moment from 'moment';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { addDays, subDays, isSameDay } from 'date-fns';

import { TextBold, TextRegular } from 'UiKit/typography';

import { useScheduleState } from 'View/schedule/state';

import styles from './styles.module.css';
import { Condition } from 'Component/others';
import { ChevronLeftIcon, ChevronRightIcon } from 'Asset/icon';

const WEEKDAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

const HeaderContent = ({ date }) => {
  const { t } = useTranslation('schedule');
  const dateNumber = moment(date?.date)?.format('DD');
  const dayKey = WEEKDAY_KEYS[moment(date?.date)?.day() ?? 0];

  const { filterState, updateFilterState } = useScheduleState();
  const { viewType, dateRange } = filterState;

  const handlePrevWeek = () => {
    if (!dateRange || !dateRange.startDate || !dateRange.endDate) return console.warn('Cannot navigate week: missing dateRange.');

    const newStartDate = subDays(dateRange.startDate, viewType.value);
    const newEndDate = subDays(dateRange.endDate, viewType.value);

    updateFilterState({
      dateRange: { startDate: newStartDate, endDate: newEndDate },
    });
  };

  const handleNextWeek = () => {
    if (!dateRange || !dateRange.startDate || !dateRange.endDate) return console.warn('Cannot navigate week: missing dateRange.');

    const newStartDate = addDays(dateRange.startDate, viewType.value);
    const newEndDate = addDays(dateRange.endDate, viewType.value);

    updateFilterState({
      dateRange: { startDate: newStartDate, endDate: newEndDate },
    });
  };

  const isFirst = dateRange?.startDate && isSameDay(date?.date, dateRange.startDate);
  const isLast = dateRange?.endDate && isSameDay(date?.date, dateRange.endDate);
  const isToday = isSameDay(date?.date, new Date());

  return (
    <Box className={`${styles['header-content__wrapper']} ${isToday && styles['header-content__wrapper--today']}`}>
      <Condition statement={isFirst}>
        <Box className={styles['header-content__prev-week--box']}>
          <ChevronLeftIcon onClick={handlePrevWeek} size="24px" />
        </Box>
      </Condition>
      <Box>
        <TextBold className={`${styles['date-number__text']} ${isToday && styles['date-number__text--today']}`}>{dateNumber}</TextBold>
        <TextRegular className={`${styles['day-name__text']} ${isToday && styles['day-name__text--today']}`}>{t(`weekdayShort.${dayKey}`)}</TextRegular>
      </Box>
      <Condition statement={isLast}>
        <Box className={styles['header-content__next-week--box']}>
          <ChevronRightIcon onClick={handleNextWeek} size="24px" />
        </Box>
      </Condition>
    </Box>
  );
};

export default HeaderContent;
